<ion-grid *ngIf="isVisible">
  <ion-row class="ion-align-items-center">
    <ion-col size="12" class="ion-text-center">
      <div class="full-background">
        <div class="advertizing-impression">
          <ion-buttons>
            <ion-button
              slot="end"
              [disabled]="advertizementMinTime > 0"
              (click)="closeAdvertizement()"
              size="small"
              class="close-btn"
              ><div>
                <p class="button-text">
                  Fecha em {{ advertizementRemainingTime }}
                </p>
              </div></ion-button
            >
          </ion-buttons>

          <div class="advertizing-impression-flex">
            <!--ion-button slot='end' (click)="toogleDisplayingImpression()">Fechar já</ion-button-->
            <ion-img src="{{ advertizementImage }}"> </ion-img>
            <div class="advertizing-impression-block">
              <p class="description">{{ advertizementDescription }}</p>
              <!--p><a href={{advertizementURL}} target="_blank">{{advertizementURLText}}</a></p-->
              <ion-button
                class="btn-external"
                (click)="openAdWithSystemBrowser(advertizementURL)"
                ><div class="button-content-container">
                  <ion-icon
                    color="inverted-text"
                    slot="start"
                    name="rocket-outline"
                  ></ion-icon>
                  <p class="bottom-button-text">{{ advertizementURLText }}</p>
                  <div></div></div
              ></ion-button>
            </div>
          </div>
        </div>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
